export default "__VITE_ASSET__W3nDU4xT__"